import { render, staticRenderFns } from "./configCommentCard.vue?vue&type=template&id=2698aa1e&scoped=true"
import script from "./configCommentCard.vue?vue&type=script&lang=js"
export * from "./configCommentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2698aa1e",
  null
  
)

export default component.exports